import React, { FC } from 'react';
import styled from 'styled-components';

import { PortalLogo } from 'componentsShared/Icons';

const TITLE = 'Welcome to OurPetPolicy';
const SUBTITLE = 'Helping protect properties one contract at a time';
const BENEFITS = [
  'Easy management for both landlords and tenants',
  'Reduce the number of fraudulent ESA letters',
  'Increase revenue with lawyer-vetted policies',
  'Reduce liability and potential legal disputes',
  'Minimize pet damage and the associated costs',
];

const SignUpIntroduction: FC = () => (
  <SContainer>
    <SLogoWrapper>
      <PortalLogo />
    </SLogoWrapper>
    <STitle>{TITLE}</STitle>
    <SSubtitle>{SUBTITLE}</SSubtitle>
    {BENEFITS.map((text) => (
      <SBenefitItem key={text}>
        <SCheckSvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
          <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z' />
        </SCheckSvg>
        <SBenefitText>{text}</SBenefitText>
      </SBenefitItem>
    ))}
  </SContainer>
);

export default SignUpIntroduction;

const SContainer = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 0 24px;
  margin: 0 auto;
`;

const SLogoWrapper = styled.div`
  top: 24px;
  position: absolute;
`;

const STitle = styled.h1`
  font-family: 'aesthet-nova', serif;
  font-weight: 500;
  font-size: 40px;
  line-height: 1.3;
  margin: 0 0 24px;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 1.5;
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    font-size: 32px;
    line-height: 1.5;
  }
`;

const SSubtitle = styled.h4`
  font-family: 'aesthet-nova';
  font-size: 20px;
  line-height: 1.5;
  font-weight: 500;
  margin: 0 0 32px;
`;

const SBenefitItem = styled.div`
  display: inline-flex;
  align-items: center;
  padding-bottom: 12px;
`;

const SCheckSvg = styled.svg`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  fill: #0d0d0d;
`;

const SBenefitText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
`;
